export default {
  disabled: false
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/node_modules/react-transition-group/esm/config.js
// module id = 2963
// module chunks = 0